import { ROUTES } from './routes';

const routeBasePathByTranslatedSlug: Record<string, string> = {
  '/products/[slug]': ROUTES.PRODUCTS,
  '/news/[slug]': ROUTES.NEWS,
  '/team/[slug]': ROUTES.TEAM,
};

interface LocaleNavigationTargetParams {
  route: string;
  asPath: string;
  translatedSlug: string | null;
}

interface LocaleNavigationTarget {
  asPath: string;
  shouldClearTranslatedSlug: boolean;
}

export const getLocaleTranslatedSlugPath = (
  route: string,
  slug: string | null,
) => {
  const basePath = routeBasePathByTranslatedSlug[route];
  const normalizedSlug = slug?.replace(/^\/+/, '').trim();

  if (!basePath || !normalizedSlug) {
    return null;
  }

  return `${basePath}/${normalizedSlug}`;
};

export const getLocaleNavigationTarget = ({
  route,
  asPath,
  translatedSlug,
}: LocaleNavigationTargetParams): LocaleNavigationTarget => {
  const translatedSlugPath = getLocaleTranslatedSlugPath(route, translatedSlug);

  if (translatedSlugPath) {
    return {
      asPath: translatedSlugPath,
      shouldClearTranslatedSlug: false,
    };
  }

  return {
    asPath,
    shouldClearTranslatedSlug: true,
  };
};
